import React from "react";
import ReactDOM from "react-dom";
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import App from "./App";
import { initAnalytics } from "./posthog";

// Analytics + visitor tracking + session replay (no-op in dev unless opted in).
initAnalytics();

ReactDOM.render(
  <MantineProvider>
    <App />
  </MantineProvider>,
  document.getElementById("root")
);
